import React,{useState,useRef,useEffect} from 'react'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import { Formik, Field, FieldArray, ErrorMessage, getIn } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import Spinner from '../../../services/spinner'
import AlertMessage from '../../../services/alert'
import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL } from '../../../services/redirect'
import { ValidateMessage } from '../../../validations/schemaMessage'
import { DropdownComponent } from '../../../components/options'
import AuthDenied from '../../ErrorPage/denied'


export default function MessageComponent(props){


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }


  const [state, setState] = useState({
    status:'1',
    title_message:'',
    body_message:'',
    footer_message:''
  });

  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','save_message');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/administrations/custom-message/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Message successfully saved.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },2000);
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });
  }


  /*------------------------------------------------------
          Message Details
  -------------------------------------------------------*/
  function MessageDetails(){

    let formData = new FormData();
    formData.append('type','details');
    axios.post('/admin/administrations/custom-message/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setState({
        ...state,
        status:obj.status,
        title_message:obj.title_message,
        body_message:obj.body_message,
        footer_message:obj.footer_message,
      });

    })
    .catch(function (error){
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });
  }

  function PreviewMessage(value){
    setnofitycontent({intent:'warning_message',settings:{
      onclose:true,
      reload:false,
      title:value.title,
      text:value.text,
      footer:value.footer,
    }});
    setnotify(true);
  }



  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [statusDropdown, setStatusDropdown] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setStatusDropdown(source.status);
  }



  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('pe4wsybrqkz1ch2tg');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1){
        }
        setloader(false);
    })
    .catch(function (error){
      setloader(false);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
    HandleOptions();
    MessageDetails();
  },[]);

  return (
    <React.Fragment>

      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

      {((authPages['view']==0||authPages['adding']==0)&&!loader)&&<AuthDenied/>}
      {(authPages['view']==1&&!loader)&&<React.Fragment>

      <div className="page-wrapper-small">
        <div className="app-page-title">
         <div className="page-title-wrapper">
            <div><h1>Message</h1></div>
            <div>
              <Button className='LigthGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
            </div>
          </div>
       </div>
      <div className="app-body-wrapper">
      <Form>
        <Formik
            enableReinitialize
            initialValues={state}
            validationSchema={ValidateMessage}
            onSubmit={handleSubmitForm}
            render={formProps => {
            const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

            return(
                    <div className="page-form-panel">
                        <div className="page-form-body">


                        <Form.Group widths="equal">
                            <Field name="title_message">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Header Text</label>
                                  <Input {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>


                        <Form.Group widths="equal">
                            <Field name="body_message">
                                {({ field, form }) => (
                                <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Message</label>
                                  <TextArea rows='5' {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>


                        <Form.Group widths="equal">
                            <Field name="footer_message">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Footer Text</label>
                                  <Input {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                          <Field name="status">
                            {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Status</label>
                                  <Select selectOnBlur={false}
                                      {...field}
                                      options={statusDropdown}
                                      onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                            )}
                          </Field>
                        </Form.Group>


                      
                        </div>{/*.page-form-body*/}

                        <div className="page-form-footer">
                            <Button disabled={spinner||authPages['adding']==0} className='PrimaryButton strong' size='small' content='Save Message' icon='save icon' onClick={handleSubmit}/>
                            {/*<Button className='LightGrayButton strong' size='small' content='Preview' icon='eye icon' onClick={() => PreviewMessage({
                               title:values.title_message,
                               text:values.body_message,
                               footer:values.footer_message,
                            })}/>*/}
                        </div>

                 </div>

            )}}/>
          </Form>
          </div>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}
